const activeTasks = [{
  type: 'task',
  'status.state': 'intent',
}, {
  type: 'task',
  'status.state': 'doing',
}];

export default activeTasks;
